import { FC } from 'react';
import './CollegeDetails.scss';
import emptyAvarter from './../../../../../Assets/images/user-empty-avatar.png';
import policelogo from './../../../../../Assets/images/logo.png';
import psclogo from './../../../../../Assets/images/psc1_logo.png';

interface propsType {
  value: any;
  disable: boolean;
}

const CollegeDetails: FC<propsType> = ({ value, disable }) => {
  const {
    surname,
    firstname,
    middlename,
    nin,
    photo,
    jobYear,
    gender,
    dob,
    stateOfPermanent,
    lgaOfPermanent,
    phone,
    email,
    authQR,
    // referenceNo,
    institution,
  } = value;
  const emailDisplay = Array.isArray(email) ? email[0] : email;
  const isAdmitted =
    institution?.metadata && institution.metadata.isQualified === true;
  const isNotAdmitted =
    institution?.metadata && institution.metadata.isQualified === false;
  const schedule = institution?.scheduleSchema || {};

  return (
    <div className='cd-details my-3'>
      {disable && (
        <div className='container-fluid'>
          <div className='row d-flex justify-content-center'>
            <div className='col-12'>
              <div className='cd-slip'>
                {/* Header */}
                <div className='cd-header'>
                  <img src={policelogo} alt='police' className='cd-logo' />
                  <div className='cd-title-block'>
                    <p className='cd-main-title'>
                      Police Constable Recruitment Status Slip
                    </p>
                    {/* <p className='cd-main-title'>
                      INTO THE NIGERIA POLICE FORCE
                    </p> */}
                    <p className='cd-year'>({jobYear || '2025/2026'})</p>
                    {isAdmitted && (
                      <p className='cd-label'>ADMISSION TO POLICE COLLEGE</p>
                    )}
                  </div>
                  <img src={psclogo} alt='psc' className='cd-logo' />
                </div>

                <div className='cd-divider' />

                {/* Profile always visible */}
                <div className='cd-content-layout'>
                  <div className='cd-fields-col'>
                    <div className='cd-section-heading'>
                      Personal Information
                    </div>

                    <div className='cd-label-row'>Name:</div>
                    <div className='cd-name-row'>
                      <div className='cd-name-col'>
                        <div className='cd-sublabel'>Surname</div>
                        <div className='cd-cell'>
                          {surname?.toUpperCase() || ''}
                        </div>
                      </div>
                      <div className='cd-name-col'>
                        <div className='cd-sublabel'>First Name</div>
                        <div className='cd-cell'>
                          {firstname?.toUpperCase() || ''}
                        </div>
                      </div>
                      <div className='cd-name-col'>
                        <div className='cd-sublabel'>Other Name</div>
                        <div className='cd-cell'>
                          {middlename?.toUpperCase() || ''}
                        </div>
                      </div>
                    </div>

                    <div className='cd-two-col-row'>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>Date of Birth:</span>
                        <div className='cd-cell'>{dob || ''}</div>
                      </div>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>Gender:</span>
                        <div className='cd-cell'>
                          {gender?.toUpperCase() || ''}
                        </div>
                      </div>
                    </div>

                    <div className='cd-two-col-row'>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>State of Origin:</span>
                        <div className='cd-cell'>{stateOfPermanent || ''}</div>
                      </div>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>LGA:</span>
                        <div className='cd-cell'>{lgaOfPermanent || ''}</div>
                      </div>
                    </div>

                    <div className='cd-two-col-row'>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>NIN:</span>
                        <div className='cd-cell'>{nin || ''}</div>
                      </div>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>Phone No.:</span>
                        <div className='cd-cell'>{phone || ''}</div>
                      </div>
                    </div>

                    <div className='cd-full-row'>
                      <div className='cd-field-item'>
                        <span className='cd-field-label'>Email Address:</span>
                        <div className='cd-cell'>{emailDisplay || ''}</div>
                      </div>
                    </div>
                  </div>

                  {/* Right: passport photo */}
                  <div className='cd-photo-col'>
                    <div className='cd-section-heading'>Candidate Photo</div>
                    {photo
                      ? <img
                        src={`${photo}`}
                        alt='passport'
                        className='cd-photo'
                      />
                      : <img
                        src={emptyAvarter}
                        alt='passport'
                        className='cd-photo'
                      />
                    }
                    {/* {referenceNo && (
                      <div className='cd-reference'>
                        <div className='cd-reference__label'>Ref No.</div>
                        <div className='cd-reference__value'>{referenceNo}</div>
                      </div>
                    )} */}
                    {isAdmitted && (
                      <div className='cd-status-badge admitted'>SELECTED</div>
                    )}
                    {isNotAdmitted && (
                      <div className='cd-status-badge not-admitted'>
                        NOT SELECTED
                      </div>
                    )}
                  </div>
                </div>

                {/* Bottom section: college info or disqualification */}
                {isAdmitted && (
                  <div className='cd-college-info-section'>
                    <div className='cd-section-heading cd-section-heading--college'>
                      Candidate College Information
                    </div>
                    <table className='cd-schedule-table cd-schedule-table--full'>
                      <tbody>
                        <tr>
                          <td>Institution</td>
                          <td>{schedule.institution || 'N/A'}</td>
                        </tr>
                        <tr>
                          <td>Status</td>
                          <td>{schedule.status || 'N/A'}</td>
                        </tr>
                        {/* <tr>
                          <td>Category</td>
                          <td>{schedule.category || 'N/A'}</td>
                        </tr> */}
                        <tr>
                          <td>Batch Phase</td>
                          <td>{schedule.batchPhase || 'N/A'}</td>
                        </tr>
                        <tr>
                          <td>Resumption Date</td>
                          <td>{schedule['resumption-date'] || 'N/A'}</td>
                        </tr>
                      </tbody>
                    </table>
                    {isAdmitted && authQR && (
                      <div className='cd-qr-row'>
                       {authQR.map((authR: string, index: number) => <img key={index}
                          src={`data:image/png;base64,${authR}`}
                          alt='auth qr'
                          className='cd-qr mx-5'
                        />)
                       }
                      </div>
                    )}
                  </div>
                )}

                {isNotAdmitted && (
                  <div className='cd-result-notice cd-result-notice--fail'>
                    <div className='cd-result-notice__heading'>
                      RESULT NOTIFICATION
                    </div>
                    <div className='cd-result-notice__body'>
                      <p className='cd-result-notice__salutation'>
                        Dear {surname?.toUpperCase()} {firstname?.toUpperCase()}
                        ,
                      </p>
                      <p className='cd-result-notice__text'>
                        Be informed that following the recruitment process
                        conducted so far, you did not meet the minimum
                        benchmark required for admission into the Police
                        College in the <strong>{jobYear || '2025'} Recruitment Exercise</strong>.
                      </p>
                      {institution?.metadata.remark && (
                        <div className='cd-result-notice__remark'>
                          <span className='cd-result-notice__remark-label'>
                            Reason(s):
                          </span>
                          {Array.isArray(institution?.metadata?.remark)
                            ? <ul>
                              {institution.metadata.remark.map(
                                (r: any, i: number) => (
                                  <li key={i}>
                                    {typeof r === 'object' && r !== null
                                      ? Object.values(r).join(', ')
                                      : r}
                                  </li>
                                ),
                              )}
                            </ul>
                            : typeof institution?.metadata?.remark === 'object' && institution.metadata.remark !== null
                              ? <ul>{Object.values(institution.metadata.remark).map((v: any, i: number) => <li key={i}>{String(v)}</li>)}</ul>
                              : <p>{institution.metadata.remark}</p>}
                        </div>
                      )}
                      <p className='cd-result-notice__text'>
                        As a result, your participation in the current
                        recruitment process ends with effect from this notice.
                        The Police Service Commission maintains strict adherence
                        to merit-based quotas and performance standards.
                      </p>
                      <p>
                        <strong>The Commission thanks you for your interest in serving the nation.</strong>
                      </p>
                    </div>
                  </div>
                )}

                {isAdmitted && (
                  <div className='cd-colour-warning'>
                    THIS SLIP MUST BE PRINTED AND PRESENTED IN COLOUR (NOT BLACK
                    AND WHITE)
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isAdmitted && (
        <div className='text-center cd-note'>
          <div>NOTE: This slip should be presented at the College.</div>
          <div>No admission will be allowed without it.</div>
        </div>
      )}
    </div>
  );
};

export default CollegeDetails;
